// Create a new file: src/addressAutocomplete.js
export function initializeAddressAutocomplete() {
    if (typeof google === 'undefined') {
        console.error('Google Maps API not loaded');
        return;
    }

    const addressInput = document.querySelector('input[name="siteAddress"]');
    if (!addressInput) return;

    const autocomplete = new google.maps.places.Autocomplete(addressInput, {
        componentRestrictions: { country: 'nz' },
        fields: ['formatted_address', 'address_components'],
        types: ['address']
    });

    // Function to handle pac-container visibility
    const hidePacContainers = () => {
        const pacContainers = document.getElementsByClassName('pac-container');
        Array.from(pacContainers).forEach(container => {
            container.style.display = 'none';  // Changed from visibility to display
        });
    };

    const showPacContainers = () => {
        const pacContainers = document.getElementsByClassName('pac-container');
        Array.from(pacContainers).forEach(container => {
            container.style.display = 'block';  // Changed from visibility to display
        });
    };

    // Hide container after place is selected
    autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (place.formatted_address) {
            addressInput.value = place.formatted_address;
            addressInput.dispatchEvent(new Event('input'));
            hidePacContainers();
            addressInput.blur();
        }
    });

    // Show container when input is focused and has value
    addressInput.addEventListener('focus', () => {
        if (addressInput.value.length > 0) {
            showPacContainers();
        }
    });

    // Input event to show container when typing
    addressInput.addEventListener('input', () => {
        if (addressInput.value.length > 0) {
            showPacContainers();
        } else {
            hidePacContainers();
        }
    });

    // Handle clicks on pac-items
    document.addEventListener('click', (e) => {
        const isPacItem = e.target.classList.contains('pac-item') || 
                         e.target.closest('.pac-item');
        const isPacContainer = e.target.classList.contains('pac-container') || 
                             e.target.closest('.pac-container');
        
        if (!isPacItem && !isPacContainer && !e.target.isSameNode(addressInput)) {
            hidePacContainers();
        }
    });

    addressInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && document.getElementsByClassName('pac-container').length > 0) {
            e.preventDefault();
        }
    });
}

export function loadGoogleMapsScript() {
    return new Promise((resolve, reject) => {
        if (typeof google !== 'undefined') {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_API_KEY}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}
